
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Select } from '@drawbotics/react-drylus';
import Playground from '~/components/Playground';
import { ControlledField } from '../utils';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


<h1>{`Select`}</h1>
<p>{`Usage`}</p>
<pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { Select } from '@drawbotics/react-drylus';
`}</code></pre>
<p><strong parentName="p">{`Example`}</strong></p>
<Playground __position={0} __code={`<ControlledField style={{ maxWidth: 250 }} component={
  <Select
    placeholder="Select an option..."
    options={[{
      label: 'Belgium',
      value: 'BE',
    }, {
      label: 'France',
      value: 'FR',
    }, {
      label: 'Italy',
      value: 'IT',
    }]} />
} />`} component={Select} mdxType="Playground">
  <ControlledField style={{
        maxWidth: 250
      }} component={<Select placeholder="Select an option..." options={[{
        label: 'Belgium',
        value: 'BE'
      }, {
        label: 'France',
        value: 'FR'
      }, {
        label: 'Italy',
        value: 'IT'
      }]} mdxType="Select" />} mdxType="ControlledField" />
</Playground>
<h3>{`Non-native select`}</h3>
<p>{`Sometimes you need a bit more information in a select (e.g. icons) then you can set the `}<inlineCode parentName="p">{`native`}</inlineCode>{` prop to `}<inlineCode parentName="p">{`false`}</inlineCode>{` and override the default select component, which normally uses the native browser `}<inlineCode parentName="p">{`select`}</inlineCode>{`.`}</p>
<Playground __position={1} __code={`<ControlledField style={{ maxWidth: 250, marginBottom: 200 }} component={
  <Select
    native={false}
    placeholder="Select an option..."
    options={[{
      label: 'Award',
      value: 'AW',
      icon: 'award',
    }, {
      label: 'Book',
      value: 'BO',
      icon: 'book',
    }, {
      label: 'Briefcase',
      value: 'BR',
      icon: 'briefcase',
    }, {
      label: 'Cloud rain',
      value: 'CL',
      icon: 'cloud-rain',
      disabled: true,
    }]} />
} />`} mdxType="Playground">
  <ControlledField style={{
        maxWidth: 250,
        marginBottom: 200
      }} component={<Select native={false} placeholder="Select an option..." options={[{
        label: 'Award',
        value: 'AW',
        icon: 'award'
      }, {
        label: 'Book',
        value: 'BO',
        icon: 'book'
      }, {
        label: 'Briefcase',
        value: 'BR',
        icon: 'briefcase'
      }, {
        label: 'Cloud rain',
        value: 'CL',
        icon: 'cloud-rain',
        disabled: true
      }]} mdxType="Select" />} mdxType="ControlledField" />
</Playground>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;